import { render, staticRenderFns } from "./FPageFinances.vue?vue&type=template&id=2d9d4a6b&"
import script from "./FPageFinances.vue?vue&type=script&lang=js&"
export * from "./FPageFinances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports